(function () {
  const styles = `
  @media (min-width: 768px) {
  #search-mobile {
    display: none !important;
}
}
//  #searchBox-mobile {
//     display: block;
// }

.search-head .input-close-btn-mobile {
    display: none;
}

.newSrchSuggestBox {
    position: absolute;
    top: 100%;
    left: 0;
    width: inherit;
    max-width: 100%;
    padding: 30px 25px 20px;
    background: #fff;
    margin-top: 2px;
    border-top: 2px solid #f9b035;
    -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .3);
    -moz-box-shadow: 0 3px 6px rgba(0, 0, 0, .3);
    box-shadow: 0 3px 6px rgba(0, 0, 0, .3);
    display: none;
    z-index: 9999 !important;
    border-radius: 10px;
    transition: none !important;
    max-height: 60vh;
    overflow-y: auto;
}

.newSrchSuggestActive {
    display: block
}

.defaultSuggestSections {
    clear: both;
    margin: 0 0 30px
}

.defaultSuggestSections h4,
.defaultSuggestSections .searchsugsthead {
    font-family: "Source Sans Pro", georgia, serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    margin: 0 0 10px !important
}

.defaultSuggestSections ul {
    font-size: 14.5px;
    line-height: 15px
}

.defaultSuggestSections ul li {
    display: inline-block;
    vertical-align: top;
    padding: 0 35px 0 0;
    margin: 0 0 12px
}

.header .defaultSuggestSections ul li a {
    display: block;
    color: #666
}

.defaultSuggestSections:last-child {
    margin-bottom: 0
}

@media (max-width: 425px) {
    .newSrchSuggestBox {
        padding: 15px 10px 20px
    }

    .defaultSuggestSections ul li {
        margin: 5px;
        padding: 5px
    }
}

@media (max-width: 340px) {
    .defaultSuggestSections ul {
        font-size: 12px
    }
}

.ui-helper-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    display: none;
    visibility: hidden
}

.forceShowSrchSuggest .ui-autocomplete.srchBarSuggest {
    display: block !important;
    margin-top: 1px
}

.ui-autocomplete.srchBarSuggest {
    position: absolute;
    top: 75% !important;
    left: 0 !important;
    list-style: none;
    padding: 0;
    margin: auto;
    right: 0;
    background: #fff;
    border: 0;
    border-top: 2px solid #333;
    height: calc(-60vh);
    max-height: 350px;
    overflow: auto;
    width: 94% !important;
    -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, .3);
    -moz-box-shadow: 0px 3px 6px rgba(0, 0, 0, .3);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, .3);
    z-index: 9999;
    height: auto;
    min-height: 220px;
    border-radius: 10px;
    transition: none !important
}

@media (max-width: 991px) {
    .ui-autocomplete.srchBarSuggest {
        top: 98% !important
    }
}

.newSrchSuggestBox,
.newSrchSuggestBox *,
.ui-autocomplete.srchBarSuggest,
.ui-autocomplete.srchBarSuggest * {
    transition: none !important
}

.srchBarSuggest::-webkit-scrollbar {
    width: 5px
}

.srchBarSuggest::-webkit-scrollbar-track {
    background: #f7f7f7
}

.srchBarSuggest::-webkit-scrollbar-thumb {
    background: #bababa
}

.ui-autocomplete {
    position: absolute
}

.ui-autocomplete.srchBarSuggest>li {
    text-align: left;
    list-style-image: none;
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer
}

.ui-autocomplete.srchBarSuggest>li:last-child {
    border-bottom: 0
}

.ui-autocomplete.srchBarSuggest>li .ui-menu-item-wrapper {
    font-size: 15px;
    line-height: 15px;
    padding: 10px 15px;
    position: relative
}

.ui-autocomplete.srchBarSuggest .ui-state-active,
.ui-autocomplete.srchBarSuggest .ui-widget-header .ui-state-active,
.ui-autocomplete.srchBarSuggest a.ui-button:active,
.ui-autocomplete.srchBarSuggest .ui-button.ui-state-active:hover {
    border: 0;
    background: #f1f1f1;
    font-weight: 400;
    color: #333;
    margin: 0
}

.searchsuggesthead {
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    margin: 0 0 5px;
    font-family: var(--font-heading-family);
}

@media (max-width: 768px) {
    .defaultSuggestSections ul li {
        margin: 5px;
        padding: 5px 8px;
        outline: 1px #e5e5e5 solid;
        border-radius: 4px;
    }
}

@media (max-width: 991px) {
    .newSrchSuggestBox {
        max-width: 100%;
        top: 100%;
        width: 100%;
        margin: 0 auto;
        right: 0
    }
}
  `;
  const styleEl = document.createElement("style");
  styleEl.textContent = styles;
  document.head.appendChild(styleEl);

  (function (win) {
    var listeners = [],
      doc = win.document,
      MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
      observer;

    function ready(selector, fn) {
      listeners.push({ selector: selector, fn: fn });
      if (!observer) {
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, { childList: true, subtree: true });
      }
      check();
    }

    function check() {
      for (var i = 0; i < listeners.length; i++) {
        var listener = listeners[i];
        var elements = doc.querySelectorAll(listener.selector);
        for (var j = 0; j < elements.length; j++) {
          var element = elements[j];
          if (!element.ready) {
            element.ready = "done";
            listener.fn.call(element, element);
          }
        }
      }
    }
    win.eleReady = ready;
  })(this);

  // Suggestion HTML
  const suggestHTML = `
    <div class="newSrchSuggestBox">
      <div class="defaultSuggestions clearfix">
        <div class="defaultSuggestSections">
          <div class="searchsuggesthead">Most Searched Categories</div>
          <ul>
            <li><a href="/collections/fabrics">Fabrics</a></li>
            <li><a href="/collections/dress-materials">Dress Materials</a></li>
            <li><a href="/collections/womens-kurtis-kurtas">Kurtas</a></li>
            <li><a href="/collections/sarees">Sarees</a></li>
            <li><a href="/collections/stitched-suit-sets">Stitched Suit Sets</a></li>
            <li><a href="/collections/dupattas">Dupattas</a></li>
            <li><a href="/collections/stoles-collection">Stoles</a></li>
            <li><a href="/collections/dresses">Dresses</a></li>
            <li><a href="/collections/bottoms-pants-salwars">Bottoms</a></li>
            <li><a href="/collections/blouse-materials">Blouse Pieces</a></li>
            <li><a href="/collections/bed-covers">Bed Covers</a></li>
            <li><a href="/collections/necklaces">Necklaces</a></li>
            <li><a href="/collections/womens-skirts">Skirts</a></li>
            <li><a href="/collections/shoulder-bags">Shoulder Bags</a></li>
          </ul>
        </div>
        <div class="defaultSuggestSections">
          <div class="searchsuggesthead">Popular Searches</div>
          <ul>
            <li><a href="/search?q=kurta">Kurta</a></li>
            <li><a href="/search?q=fabrics">Fabrics</a></li>
            <li><a href="/search?q=batik+kurti+palazzo+dupatta+set">Batik Kurti Palazzo Dupatta Set</a></li>
            <li><a href="/search?q=kalamkari">Kalamkari</a></li>
            <li><a href="/search?q=ikat">Ikat</a></li>
            <li><a href="/search?q=bag">Bag</a></li>
            <li><a href="/search?q=ajrakh">Ajrakh</a></li>
            <li><a href="/search?q=silk">Silk</a></li>
            <li><a href="/search?q=dharwad">Dharwad</a></li>
            <li><a href="/search?q=bhagalpuri+stitched">Bhagalpuri Stitched</a></li>
            <li><a href="/search?q=dupatta">Dupatta</a></li>
          </ul>
        </div>
        <div class="defaultSuggestSections">
          <div class="searchsuggesthead">Popular Collections</div>
          <ul>
            <li><a href="/collections/fabrics">Fabrics</a></li>
            <li><a href="/collections/latest-collections-on-ekdum-fresh">Latest Collections On Ekdum Fresh</a></li>
            <li><a href="/collections/womens-kurtis-kurtas">Womens Kurtis Kurtas</a></li>
            <li><a href="/collections/dress-materials">Dress Materials</a></li>
            <li><a href="/collections/dharward-handloom-dress-materials-online">Dharward Handloom Dress Materials</a></li>
            <li><a href="/collections/bagru-block-printed-kurtis">Bagru Block Printed Kurtis</a></li>
            <li><a href="/collections/clothing-for-women">Clothing For Women</a></li>
            <li><a href="/collections/pochampally-ikat-dress-materials">Pochampally Ikat Dress Materials</a></li>
            <li><a href="/collections/ajrakh-ajrak-dress-materials-online">Ajrakh Ajrak Dress Materials</a></li>
            <li><a href="/collections/kalamkari-fabrics">Kalamkari Fabrics</a></li>
            <li><a href="/collections/sarees">Sarees</a></li>
            <li><a href="/collections/bagh-block-printed-kurtis">Bagh Block Printed Kurtis</a></li>
          </ul>
        </div>
      </div>
    </div>
  `;

  eleReady('#st-search', (searchInput) => {
    let suggestBox;

    function injectSuggestBox() {
      if (!suggestBox) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = suggestHTML;
        suggestBox = wrapper.firstElementChild;
        searchInput.parentNode.insertBefore(suggestBox, searchInput.nextSibling);
      }
    }

    function showSuggestBox() {
      if (suggestBox) {
        suggestBox.classList.add("newSrchSuggestActive");
        suggestBox.style.display = "none";
      }
    }

    function hideSuggestBox() {
      if (suggestBox) {
        suggestBox.classList.remove("newSrchSuggestActive");
        suggestBox.style.display = "none";
      }
    }

    searchInput.addEventListener("focus", function () {
      injectSuggestBox();
      if (searchInput.value.trim() === "") showSuggestBox();
    });

    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() === "") {
        showSuggestBox();
      } else {
        hideSuggestBox();
        
        const originalPushState = history.pushState;
        history.pushState = function (state, title, url) {
          const result = originalPushState.apply(this, arguments);

          if (url && url.includes("/search")) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            // searchInput.focus();
          }

          // history.pushState = originalPushState;
          return result;
        };
      }
    });

    document.addEventListener("click", function (e) {
      if (suggestBox && !suggestBox.contains(e.target) && e.target !== searchInput && e.target !== document.querySelector('span#search-mobile') && e.target !== document.querySelector('.st-searchicon') && e.target !== document.querySelector('.st-input-query-clear') && e.target !== document.querySelector('.st-input-query-clear path')) {
        hideSuggestBox();
      }
    });
  });
})();
